import { PaginatedGridProps } from './PaginatedGrid.interfaces';
import EditableGrid from './EditableGrid';

const PaginatedGrid = (restProps: PaginatedGridProps) => {
  return <EditableGrid {...restProps} />;
};

export default PaginatedGrid;
